import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { CategoryDiscoveryOption } from 'src/core/models/enum/category-discovery-option.enum';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
  selector: 'ca-topic-training-started-notification',
  templateUrl: './topic-training-started-notification.component.html',
  styleUrls: ['./topic-training-started-notification.component.scss'],
  standalone: false,
})
@NotificationType('TopicTrainingStartedNotification', TopicTrainingStartedNotificationComponent)
export class TopicTrainingStartedNotificationComponent implements OnInit {
  data: NotificationDto;

  get dataCount(): string {
    return this.data ? JSON.parse(this.data.payload).dataCount : '';
  }

  get trainOption(): string {
    return this.data ? JSON.parse(this.data.payload).trainOption : '';
  }

  constructor(public categoryDiscoveryOption: CategoryDiscoveryOption) {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
  ) {
    const categoryDiscoveryOption = injector.get(CategoryDiscoveryOption);
    const parsedPayload = JSON.parse(payload);
    let message = localizationService.instant(
      'AITopic::TopicTrainWithDialoguesStartedMessage',
      parsedPayload.dataCount,
    );
    if (parsedPayload.trainOption == categoryDiscoveryOption.DialoguesAndCategories.toString()) {
      message = localizationService.instant(
        'AITopic::TopicTrainWithBothStartedMessage',
        parsedPayload.dataCount,
      );
    } else if (parsedPayload.trainOption == categoryDiscoveryOption.OnlyCategories.toString()) {
      message = localizationService.instant('AITopic::TopicTrainWithCategoriesStartedMessage');
    }
    toastr.success(message);
  }
}
